export default __webpack_public_path__ + "static/media/DSC08595.1c059efd.jpg";